import { FormikProps } from "formik";
import RichTextEditor from "../../../../../components/richTextEditor/RichTextEditor";
import Flex from "../../../../../components/Flex";
import Input from "../../../../../components/Input";
import { RosTemplate } from "../../../../../services";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Text from "../../../../../components/Text";
import CustomTooltip from "../../../../../components/CustomTooltip";
import DynamicVariablesTooltip from "./DynamicVariablesTooltipForEmail";
import { Box } from "@mui/material";

interface EmailFormProps {
  formik: FormikProps<RosTemplate>;
  disabled?: boolean;
}

/**
 * @author [Rajkumar Rathod]
 */
const EmailForm = ({ formik, disabled }: EmailFormProps) => {
  return (
    <Flex gap={2} flexDirection={"column"} mt={2}>
      <Input
        label="Subject"
        required
        textFieldProps={{
          name: "subject",
          disabled: disabled,
          value: formik.values.subject,
          onChange: formik.handleChange,
          onBlur: formik.handleBlur,
          placeholder: "Enter Subject",
        }}
        error={formik.touched?.subject && formik.errors?.subject}
      />
      {!disabled && (
        <Box sx={{ flex: "0 0 auto", alignSelf: "flex-start" }}>
          <CustomTooltip
            content={<DynamicVariablesTooltip />}
            position="right-end"
            disableTooltip={false}
            width="500px"
          >
            <Text>
              Dynamic Variables <InfoOutlinedIcon fontSize="small" />
            </Text>
          </CustomTooltip>
        </Box>
      )}
      <RichTextEditor
        disabled={disabled}
        minRows={20}
        name="description"
        placeholder="Type Something..."
        onBlur={formik.handleBlur}
        value={formik.values?.description}
        onChange={formik.handleChange}
        error={
          formik.touched?.description && formik.errors?.description
            ? formik.errors?.description
            : undefined
        }
      />
    </Flex>
  );
};

export default EmailForm;
